import React, { Suspense } from 'react';
import BusminApp from 'App';

import Loader from 'components/Loader';

const LeaseIQApp = React.lazy(() => import('./ClientApps/LeaseIQ/src/App'));

const AppSelector: React.FC = () => {
  const organisation = process.env.REACT_APP_ORGANISATION || 'EEA';

  if (organisation === 'LEASEIQ') {
    return (
      <Suspense fallback={<Loader open />}>
        <LeaseIQApp />
      </Suspense>
    );
  }

  return <BusminApp />;
};

export default AppSelector;
